module.exports = __webpack_public_path__ + "img/jeep-vehicle.b0ce1b8b.png";